export default {
  methods: {
    setCookie(_keyName, _value) {
      this.$cookies.set(_keyName, _value)
    }
  }
}
